<template>
    <OverlayLoader :isLoading="!isLoaded">
        <main class="page page-dashboard">
            <div class="container">

                <PageHeader
                    :title="$translate.text('general.languages')"
                />

                <ConnectionMenu></ConnectionMenu>

                <form @submit.prevent="submitForm" method="POST">
                    <div class="language">
                        <Select
                            id="language"
                            :value="language.language_shop_id"
                            name="language"
                            @change="language.language_shop_id = $event"
                            :options="unusedLanguages"
                            :label="$translate.text('clients.connections.language.shopname')"
                        />

                        <TextInput
                            id="code"
                            :value="language.code"
                            name="code"
                            @change="language.code = $event"
                            :label="$translate.text('clients.connections.language.code')"
                            :placeholder="`code`"
                            :required="true"
                        />

                        <Select
                            v-if="content_provider.active && content_provider.provider === 'icecat'"
                            id="ContentProviderLanguage"
                            :value="cp_language"
                            name="ContentProviderLanguage"
                            @change="cp_language = $event"
                            :options="contentProviderLanguages.icecat"
                            :label="$translate.text('clients.connections.language.icecat.language')"
                        />

                        <div class="form-group" v-if="content_provider.active && content_provider.provider === 'icecat'">
                            <div class="info-bar">
                                {{ t('clients.connections.provider.language.infobar.icecat_language')}}
                            </div>
                        </div>

                        <TextInput
                            id="related"
                            :value="language.related"
                            name="related"
                            @change="language.related = $event"
                            :label="$translate.text('clients.connections.language.related')"
                            :placeholder="`Related`"
                            :required="false"
                        />

                        <TextInput
                            id="cross_sell"
                            :value="language.cross_sell"
                            name="cross_sell"
                            @change="language.cross_sell = $event"
                            :label="$translate.text('clients.connections.language.cross_sell')"
                            :placeholder="`Similar`"
                            :required="false"
                        />
                    </div>
                    <div v-if="selectedLanguage">
                        <div class="row" >
                            <div class="col-sm-3">
                                <h4>{{ t('client.feeds.combine.combine') }}</h4>
                            </div>
                            <div class="col-sm"></div>
                            <div class="col-sm">
                                <h4>{{ t('client.feeds.combine.draganddrop') }}</h4>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-8" style="display:flex; overflow: auto; height: 700px; padding: 0px;">
                                <div class="col-sm-4">

                                    <input type="text" v-model="search_combinable" class="form-input" placeholder="Zoeken..." style="  height: 37px; width: 100%; border: none; border-radius: 4px; padding: 8px; margin-top: 10px;" />

                                    <div v-for="(item, index) in combinableValues" :key="index" class="list-group-item list-group-item--header" :style="{'height': `${(37 * item.placeholders.length) + (10 * (item.placeholders.length-1))}px`}">
                                        <span v-if="item.type === 'basic'">{{ t(`client.feeds.combine.columns.${item.name}`) }}</span>
                                        <span v-else>{{ item.name }}</span>
                                        <span v-if="item.required">*</span>
                                        <i class="fal fa-plus pointer" v-if="item.name === 'image'" style="float:right;" @click="appendPlaceholder(index)" v-tooltip.bottom="$translate.text('tooltip.append')"></i>
                                    </div>
                                </div>
                                <div class="col-sm-8">

                                    <div style="height: 47px;">&nbsp;</div>

                                    <template v-for="(item, itemIndex) in combinableValues">
                                        <drop
                                            class="drop list-group-item list-group-item--drop"
                                            v-for="(placeholder, placeholderIndex) in item.placeholders"
                                            :key="`labels-${itemIndex}-placeholders-${placeholderIndex}`"
                                            :class="{'list-group-item--targeted': placeholder.hovered, 'list-group-item--holder': placeholder.value === ''}"
                                            @drop="dropHandle($event, itemIndex, placeholderIndex)"
                                            @dragenter="dragEnter(itemIndex, placeholderIndex)"
                                            @dragleave="dragLeave(itemIndex, placeholderIndex)"
                                        >
                                            {{ placeholder.value }}
                                            <i class="fal fa-trash-alt pointer" v-if="placeholder.value !== ''" style="float:right;" @click="dropClear(itemIndex, placeholderIndex)" v-tooltip.bottom="$translate.text('tooltip.delete')"></i>
                                        </drop>
                                    </template>
                                </div>
                            </div>
                            <div class="col-sm" style="overflow: auto;height: 700px;">

                                <input type="text" v-model="search" class="form-input" placeholder="Zoeken..." style="  height: 37px; width: 100%; border: none; border-radius: 4px; padding: 8px; margin-top: 10px;" />

                                <drag
                                    class="drag list-group-item list-group-item--drag"
                                    v-for="(item, index) in uncombinedValues"
                                    :key="index"
                                    :transfer-data="item.key"
                                >
                                    <i class="fal fa-arrows"></i> {{ item.key }}
                                    <i class="fal fa-eye" v-tooltip.top="$translate.text('general.example') + `: ` + item.example" :popoverInnerClass="`tooltip-inner-boxed`"></i>
                                </drag>
                            </div>
                        </div>

                        <div class="col-sm-12">
                            <FormSubmit
                                :routeAfterCancelLink="{ name: 'Clients Connections Languages', params: this.$route.params.id }"
                                :buttonLabel="submittingIsLoading ? $translate.text('general.save.saving') :  $translate.text('general.save')"
                                :disabled="submittingIsLoading  || this.language === null"
                            />
                        </div>
                    </div>

                </form>
            </div>
        </main>
    </OverlayLoader>
</template>
<script>
import swal from 'sweetalert';

import OverlayLoader from '@/components/OverlayLoader/OverlayLoader';

import PageHeader from '@/components/PageHeader/PageHeader';
import FormSubmit from '@/components/Forms/FormSubmit';
import handleError from '@/helpers/error';
import Select from '@/components/Inputs/Select';
import TextInput from '@/components/Inputs/TextInput';
import ConnectionMenu from '@/components/ConnectionMenu/ConnectionMenu';

export default {
    name: 'AddLanguage',

    components: {
        PageHeader,
        FormSubmit,
        OverlayLoader,
        Select,
        TextInput,
        ConnectionMenu,
    },

    data() {
        return {

            search_combinable: '',
            search: '',

            combineables: [],

            loaded: {
                combineables: false,
                values: false,
                languages: false,
            },

            language: {
                name: '',
                code: '',
                description: '',
                related: '',
                cross_sell: '',
                language: '',
                language_shop_id: null,
            },

            languages: [],
            connectionLanguages: [],

            feedId: null,

            cp_language: null,

            content_provider: {
                active: false,
                provider: null,
                language: null,
            },

            contentProviderLanguages: {
                icecat: [
                    { label: this.$translate.text('general.select_option'), value: null, disabled: true },
                    { label: this.$translate.text('icecat.languages.en'), value: 'en' },
                    { label: this.$translate.text('icecat.languages.nl'), value: 'nl' },
                    { label: this.$translate.text('icecat.languages.fr'), value: 'fr' },
                    { label: this.$translate.text('icecat.languages.de'), value: 'de' },
                    { label: this.$translate.text('icecat.languages.it'), value: 'it' },
                    { label: this.$translate.text('icecat.languages.es'), value: 'es' },
                    { label: this.$translate.text('icecat.languages.dk'), value: 'dk' },
                    { label: this.$translate.text('icecat.languages.ru'), value: 'ru' },
                    { label: this.$translate.text('icecat.languages.us'), value: 'us' },
                    { label: this.$translate.text('icecat.languages.br'), value: 'br' },
                    { label: this.$translate.text('icecat.languages.pt'), value: 'pt' },
                    { label: this.$translate.text('icecat.languages.zh'), value: 'zh' },
                    { label: this.$translate.text('icecat.languages.sv'), value: 'sv' },
                    { label: this.$translate.text('icecat.languages.pl'), value: 'pl' },
                    { label: this.$translate.text('icecat.languages.cz'), value: 'cz' },
                    { label: this.$translate.text('icecat.languages.hu'), value: 'hu' },
                    { label: this.$translate.text('icecat.languages.fi'), value: 'fi' },
                    { label: this.$translate.text('icecat.languages.el'), value: 'el' },
                    { label: this.$translate.text('icecat.languages.no'), value: 'no' },
                    { label: this.$translate.text('icecat.languages.tr'), value: 'tr' },
                    { label: this.$translate.text('icecat.languages.bg'), value: 'bg' },
                    { label: this.$translate.text('icecat.languages.ka'), value: 'ka' },
                    { label: this.$translate.text('icecat.languages.ro'), value: 'ro' },
                    { label: this.$translate.text('icecat.languages.sr'), value: 'sr' },
                    { label: this.$translate.text('icecat.languages.uk'), value: 'uk' },
                    { label: this.$translate.text('icecat.languages.ja'), value: 'ja' },
                    { label: this.$translate.text('icecat.languages.ca'), value: 'ca' },
                    { label: this.$translate.text('icecat.languages.es_ar'), value: 'es_ar' },
                    { label: this.$translate.text('icecat.languages.hr'), value: 'hr' },
                    { label: this.$translate.text('icecat.languages.ar'), value: 'ar' },
                    { label: this.$translate.text('icecat.languages.vi'), value: 'vi' },
                    { label: this.$translate.text('icecat.languages.ko'), value: 'ko' },
                    { label: this.$translate.text('icecat.languages.mk'), value: 'mk' },
                    { label: this.$translate.text('icecat.languages.sl'), value: 'sl' },
                    { label: this.$translate.text('icecat.languages.en_sg'), value: 'en_sg' },
                    { label: this.$translate.text('icecat.languages.en_za'), value: 'en_za' },
                    { label: this.$translate.text('icecat.languages.zh_tw'), value: 'zh_tw' },
                    { label: this.$translate.text('icecat.languages.he'), value: 'he' },
                    { label: this.$translate.text('icecat.languages.lt'), value: 'lt' },
                    { label: this.$translate.text('icecat.languages.lv'), value: 'lv' },
                    { label: this.$translate.text('icecat.languages.en_in'), value: 'en_in' },
                    { label: this.$translate.text('icecat.languages.de_ch'), value: 'de_ch' },
                    { label: this.$translate.text('icecat.languages.id'), value: 'id' },
                    { label: this.$translate.text('icecat.languages.sk'), value: 'sk' },
                    { label: this.$translate.text('icecat.languages.fa'), value: 'fa' },
                    { label: this.$translate.text('icecat.languages.ex_mx'), value: 'ex_mx' },
                    { label: this.$translate.text('icecat.languages.et'), value: 'et' },
                    { label: this.$translate.text('icecat.languages.de_be'), value: 'de_be' },
                    { label: this.$translate.text('icecat.languages.fr_be'), value: 'fr_be' },
                    { label: this.$translate.text('icecat.languages.nl_be'), value: 'nl_be' },
                    { label: this.$translate.text('icecat.languages.th'), value: 'th' },
                ],
            },

            values: [],

            submittingIsLoading: false,
        };
    },

    created() {
        this.getCombineables();
        this.getConnection();
        this.getLanguages();
    },

    methods: {

        dropHandle(data, itemIndex, placeholderIndex) {
            this.combinableValues[itemIndex].placeholders[placeholderIndex].hovered = false;
            this.combinableValues[itemIndex].placeholders[placeholderIndex].value = data;
        },

        dropClear(itemIndex, placeholderIndex) {
            this.combinableValues[itemIndex].placeholders[placeholderIndex].value = '';
        },

        dragEnter(itemIndex, placeholderIndex) {
            this.combinableValues[itemIndex].placeholders[placeholderIndex].hovered = true;
        },

        dragLeave(itemIndex, placeholderIndex) {
            this.combinableValues[itemIndex].placeholders[placeholderIndex].hovered = false;
        },

        appendPlaceholder(index) {
            this.combinableValues[index].placeholders.push({
                hovered: false,
                value: '',
            });
        },

        getConnection() {
            this.API.clients.connections.show(this.$route.params.id)
                .then(response => {
                    const connection = response.data.data;
                    this.feedId = connection.feed_id;
                    this.content_provider = {
                        active: connection.content_provider.active,
                        provider: connection.content_provider.provider,
                        language: connection.content_provider.language,
                    };

                    this.getValues();
                    // this.getCombined();
                }).catch(error => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },


        getValues() {
            const id = this.feedId;
            this.API.clients.feeds.combine.values(id)
                .then(response => {
                    this.values = response.data;
                    this.loaded.values = true;
                }).catch(error => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        getCombineables() {
            this.API.clients.connections.languages.combineables(this.$route.params.id)
                .then(response => {
                    this.combineables = response.data;
                    this.loaded.combineables = true;

                    this.getConnectionLanguages();
                }).catch(error => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        getLanguages() {
            const id = this.$route.params.id;
            this.API.clients.connections.languages.index(id)
                .then((response) => {
                    const item = [{
                        id: null,
                        label: this.$translate.text('general.select_option'),
                        value: null,
                    }];
                    response.data.language_shops.forEach(lang => {
                        lang.value = lang.id;
                        item.push(lang);
                    });
                    // languages.push(item);
                    this.languages = item;
                    this.loaded.languages = true;
                })
                .catch((error) => {
                    console.log(error);
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        getConnectionLanguages() {
            const id = this.$route.params.id;
            this.API.clients.connections.languagesIndex(id)
                .then((response) => {
                    this.connectionLanguages = response.data.data;
                })
                .catch((error) => {
                    console.log(error);
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        getCombined() {
            const id = this.feedId;
            this.API.clients.feeds.combine.combined(id)
                .then(response => {
                    if (response.data.data) {
                        const data = response.data.data;

                        Object.keys(data).forEach(index => {
                            const indexOf = this.combineables.findIndex(i => i.name === index);
                            if (indexOf > -1) {
                                this.combineables[indexOf].placeholders = [];

                                data[index].forEach(value => {
                                    this.combineables[indexOf].placeholders.push({
                                        hovered: false,
                                        value: value !== null ? value : '',
                                    });
                                });
                            }
                        });
                    }

                    this.loaded.combined = true;
                }).catch(error => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        submitForm() {
            const id = this.$route.params.id;
            const data = {
                name: '',
                code: '',
                description: '',
                language: '',
                language_shop_id: null,
                cp_language: null,
                content_provider: {
                    active: false,
                    provider: null,
                    language: null,
                },
                attributes: [],
            };
            const errors = [];

            this.combineables.forEach(item => {
                item.placeholders.forEach(placeholder => {
                    if (item.required && placeholder.value === '') {
                        errors.push(
                            `- ${this.$translate.text('clients.feeds.combine.required').replace('%field%', this.$translate.text(`client.feeds.combine.columns.${item.name}`))}`,
                        );
                    } else if (placeholder.value !== '') {
                        if (item.type === 'basic') {
                            if (item.name === 'description') {
                                data.description = placeholder.value;
                            } else if (item.name === 'name') {
                                data.name = placeholder.value;
                            }
                        } else if (item.type === 'attribute') {
                            data.attributes.push({
                                'attribute': item.name,
                                'feed_name': placeholder.value,
                            });
                        }
                    }
                });
            });

            // eslint-disable-next-line
            const language = this.languages.find(languagevalue => languagevalue.id == this.language.language_shop_id);

            data.language = language.name;
            data.code = this.language.code;
            data.language_shop_id = language.id;
            data.cp_language = this.cp_language;
            data.content_provider = this.content_provider;
            data.related = this.language.related;
            data.cross_sell = this.language.cross_sell;

            if (errors.length > 0) {
                swal({
                    title: this.$translate.text('alert.whoops'),
                    text: errors.join('\n'),
                });
            } else {
                this.API.clients.connections.languages.update(id, data.language_shop_id, data)
                    .then(() => {
                        this.submittingIsLoading = false;
                        this.$router.push({ name: 'Clients Connections Languages', params: id });
                    })
                    .catch((error) => {
                        this.submittingIsLoading = false;
                        handleError({
                            error,
                            message: this.$translate.text('alert.whoops'),
                        });
                    });
            }
        },

    },

    computed: {
        isLoaded() {
            return this.loaded.values && this.loaded.languages;
        },

        combinableValues() {
            const combinable = this.combineables;

            if (this.search_combinable.length > 0) {
                return combinable.filter(value => {
                    if (value.type === 'basic') {
                        return this.$translate.text(`client.feeds.combine.columns.${value.name}`).toLowerCase().includes(this.search_combinable.toLowerCase());
                    }

                    return value.name.toLowerCase().includes(this.search_combinable.toLowerCase());
                });
            }

            return combinable;
        },

        uncombinedValues() {
            const combined = [];

            this.combineables.forEach(item => {
                item.placeholders.forEach(placeholder => {
                    if (placeholder.value) {
                        if (placeholder.value.length > 0) {
                            combined.push(placeholder.value);
                        }
                    }
                });
            });

            const filtered = this.values.filter(value => !combined.includes(value.key));

            if (this.search.length > 0) {
                return filtered.filter(value => value.key.toLowerCase().includes(this.search.toLowerCase()));
            }

            return filtered;
        },

        unusedLanguages() {
            this.languages.forEach(language => {
                this.connectionLanguages.forEach(connectLanguage => {
                    if (language.id === connectLanguage.language_shop_id) {
                        language.disabled = true;
                        return false;
                    }
                });
            });
            return this.languages;
        },

        selectedLanguage() {
            if (this.language.language_shop_id === null) {
                return false;
                // eslint-disable-next-line
            } else if (this.language.language_shop_id == '') {
                return false;
            }
            return true;
        },
    },
};
</script>
<style lang="scss" scoped>

    .form-group {
        display: flex;
        align-items: center;

        .info-bar {
            margin-left: 270px;
            background: rgba($blue, .1);
            border: 1px solid $blue;
            padding: 10px;
            font-size: $font-size-base * 0.8;
            border-radius: 5px;
            width: 100%;
        }
    }

</style>
